import(/* webpackMode: "eager" */ "/home/runner/work/pluswilla/pluswilla/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pluswilla/pluswilla/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Work_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-work-sans\",\"display\":\"swap\"}],\"variableName\":\"workSans\"}");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pluswilla/pluswilla/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/pluswilla/pluswilla/src/app/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/pluswilla/pluswilla/src/app/Schema.tsx");
